// deps
import React, { ReactElement, memo, useMemo } from "react";

// internal-deps
import { format } from "@swiggy-private/core-ui";

// interfaces
import { FoodCardData, CardPaymentMethodData } from "@payment-ui/interfaces";

// widgets
import Alert from "@payment-ui/widgets/alert/Alert";

// constants
import { LOW_CARD_BALANCE_MESSAGE } from "@payment-ui/constants/Card";

// helpers
import { getCardMethodTestIds } from "@payment-ui/helpers/Card";

import styles from "../Card.v4.scss";

interface AlertMessageProps {
    isMethodEnabled: boolean;
    isBalanceLoading: boolean;
    hasSufficentBalance: boolean;
    cardData: FoodCardData;
    methodData: CardPaymentMethodData;
}

function AlertMessage(props: AlertMessageProps): ReactElement | null {
    const { isMethodEnabled, isBalanceLoading, hasSufficentBalance, cardData, methodData } = props;
    const testIds = useMemo(() => getCardMethodTestIds(methodData), [methodData]);

    if (!isMethodEnabled) {
        return (
            <Alert
                className={styles.paymentMethodDisable}
                message={methodData.meta.disableMessage}
                data-testid={testIds.DISABLE_MESSAGE}
            />
        );
    }

    if (!isBalanceLoading && !hasSufficentBalance) {
        return (
            <Alert
                className={styles.paymentMethodAlert}
                message={format(LOW_CARD_BALANCE_MESSAGE, Number(cardData.additionalBalanceRequired).toFixed(2))}
                data-testid={testIds.ALERT_MESSAGE}
            />
        );
    }

    return null;
}

export default memo(AlertMessage);
